import { useStore } from "@nanostores/react"

import { useEvent } from "shared/lib/useEvent"

import { ProductFilterFormData } from "entities/products/types/ProductFilter"

import {
  productCategoryFilterStore,
  resetFilterState,
  setFilterState
} from "./product-category-filter-store"

const defaultFilterState: ProductFilterFormData = {}

export function useProductCategoryFilterStore({
  productCategoryID
}: {
  productCategoryID: string
}) {
  const state = useStore(productCategoryFilterStore, {
    keys: [productCategoryID]
  })

  const setFilters = useEvent((newState: ProductFilterFormData) => {
    setFilterState(productCategoryID, newState)
  })

  const resetFilters = useEvent(() => {
    resetFilterState()
  })

  return {
    filterState: state[productCategoryID] || defaultFilterState,
    setFilters,
    resetFilters
  }
}
